import React, { useEffect, useState } from "react";
import api from "../api/api";
import { orderAccess } from "../utils/directPayment";

export default function PaymentReceiptPreview({ receiptId, orderId }) {
  const [preview, setPreview] = useState(null);
  useEffect(() => {
    let active = true,
      url;
    setPreview(null);
    api
      .get(`/payment/direct/receipts/${receiptId}`, {
        ...orderAccess(orderId),
        responseType: "blob",
      })
      .then(({ data }) => {
        if (!active) return;
        if (["image/png", "image/jpeg"].includes(data.type)) {
          url = URL.createObjectURL(data);
          setPreview(url);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [receiptId, orderId]);
  return preview ? (
    <img
      src={preview}
      alt="Uploaded payment receipt"
      className="max-h-64 max-w-full rounded-lg border object-contain"
    />
  ) : null;
}
